import { Formik, FormikActions, FormikProps } from 'formik';
import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { SelectAsync, SelectNoneAsync } from '../../components/input/select/main';
import Translator from '../../core/i18n';
import { IAction, IAppState } from '../../models/action/core';
import { Notification } from '../../components/notification/main';
import { IPagedQueryS } from '../../models/components/paginate';
import { Common } from '../../core/common';
import { ICourseList } from '../../models/pages/coursePage';
import * as ActionsUserHome from '../../store/actions/userHome';
import { UserType } from '../../models/pages/login.d';
import { ICourseFilters } from '../../models/components/user-home_my_courses';
import { Status } from '../../models/enums/Status';
import Input from '../../components/input/text/input-formik';
import { colors } from 'react-select/lib/theme';
import { Button } from '../../components/ui-elements/main';

const T = Translator.create();
const _logger = Log.create('Filter Courses');
let _common: Common;

interface ISelectCourseStatus {
    value: any;
    label: string;
}

export class FilterCourses extends Component<ICourseList, any> {
    public state = {
        isTeacher: (this.props.userType && (this.props.userType === UserType.Teacher || this.props.userType === UserType.ProgramAdmin)) ? true : false,
        filters: {
            page: 1,
            take: 28,
            total: 0
        },
        isAll: false,
        filterInitialValues: {
            searchTermId: '',
            searchProgId: '',
            masterCourseId: '',
            sourceCourseId: '',
            status: -1,
            searchCourseName: '',
            courseId: ''
        },
        isSelected: false,
    }

    constructor(props: any) {
        super(props);
        _common = new Common();
        this.onSubmit.bind(this);
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.userHomeMyCourses &&
            this.props.userHomeMyCourses &&
            prevProps.userHomeMyCourses !== this.props.userHomeMyCourses) {
            this.setState({
                isAll: false,
                filterInitialValues: {
                    searchTermId: '',
                    searchProgId: '',
                    masterCourseId: '',
                    sourceCourseId: '',
                    status: -1,
                    searchCourseName: '',
                    courseId: ''
                }
            });
        }
    }

    onSubmit = async (model: ICourseFilters, FormActions: FormikActions<any>) => {

        await this.getCourses(model, this.state.filters);
        this.props.changeLessonStatus(model.status)

        FormActions.setSubmitting(false);
    };

    getCourses = async (filters: ICourseFilters, paging: IPagedQueryS) => {
        filters.searchProgId = filters.searchProgId ? filters.searchProgId.split("-")[0] : '';
        filters.searchTermId = filters.searchTermId ? filters.searchTermId.split("-")[0] : '';
        filters.masterCourseId = filters.masterCourseId ? filters.masterCourseId.split("-")[0] : '';
        filters.courseId = filters.courseId ? filters.courseId.split("-")[0] : '';
        this.props.dispatch(ActionsUserHome.getUserHomeMyCourses(this.state.isTeacher, 'getUserHomeMyCoursesFilter', 'get', '', filters));
        this.setState({ filterInitialValues: filters });
    };

    public handleSelectCourseStatus = (e: ISelectCourseStatus[]): Status[] => {
        const courseStatus: Status[] = [];
        if (e && e.length) {
            e.forEach(course => courseStatus.push(course.value));
        }
        return courseStatus;
    }

    validateAndSubmit = async (formik: FormikProps<any>) => {
        let isCompleted: boolean = true;

        const validations = await formik.validateForm().then((result: any) => result);
        Object.keys(validations).forEach((validationKey: string) => {
            Notification.setNotification(
                'error',
                T.t('r_validation_gen_' + validationKey) + ' - ' + validations[validationKey],
                'topRight'
            );

            isCompleted = false;
        });
        if (isCompleted) {
            formik.submitForm();
            this.setState({ isSelected: true })
        }
        const searched = document.getElementById('searched');
        const unsearched = document.getElementById('unsearched');
        if (unsearched && searched) {
            unsearched.className = "d-none";
            searched.className = "d-block";
        }

    };

    public onChangeSelectCondition(selectValue: any, formik: FormikProps<any>) {
        formik.setFieldValue('status', selectValue ? selectValue.value : "-1");
    }

    public render() {
        const courseStatus = [
            { value: Status.Active, label: T.t('r_gen_status_active') },
            { value: Status.Passive, label: T.t('r_gen_status_passive') },
        ];
        return (
            <div className="filter-fields mb-2" style={{width: "100%"}}>
                <Formik
                    initialValues={this.state.filterInitialValues}
                    onSubmit={this.onSubmit}
                >
                    {formik => {
                        return (
                            <>
                                <form onSubmit={formik.handleSubmit} key={'project_add_user_modal'} noValidate={true}>
                                    <div className="row align-items-baseline">
                                        <div className="col-md-4 col-sm-12">
                                            <div className="  date-picker ">
                                                <Input
                                                    type={'text'}
                                                    name={'searchCourseName'}
                                                    label={T.t('r_gen_filter_course_parameter_courseName')}
                                                    formik={formik}
                                                />

                                            </div>
                                        </div>

                                        <div className="col-md-4 col-sm-12">
                                            <div className="k365-input date-picker">
                                            <label  className="input-label">{T.t('r_gen_questionBank_questionTerm')}</label>
                                                <SelectAsync
                                                    isMulti={false}
                                                    className='k365-select'
                                                    isSearchable={true}
                                                    requestType={'post'}
                                                    parameter={{ SearchedText: '', GetTypes: 'Term', Skip: 0, Take: 10, IsForStudent: !this.state.isTeacher }}
                                                    placeHolder={T.t('r_gen_questionBank_questionTerm')}
                                                    url={'api/organization/search'}
                                                    closeMenuOnScroll={false}
                                                    closeMenuOnSelect={false}
                                                    name={"searchTermId"}
                                                    value={formik.values.searchTermId}
                                                    onChange={formik.handleChange}
                                                    setFieldValue={formik.setFieldValue}
                                                    errors={formik.errors.searchTermId}
                                                    touched={formik.touched.searchTermId}
                                                    isTouched={formik.setFieldTouched}
                                                    hasLocalization={true}
                                                    setFieldOnlyValue={true}
                                                    isClearable={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-4 col-sm-12">
                                            <div className="k365-input date-picker">

                                            <label  className="input-label">{T.t('r_gen_filter_course_parameter_courseStatus')}</label>
                                                <SelectNoneAsync
                                                    isMulti={false}
                                                    name={'status'}
                                                    className='k365-select'
                                                    touched={formik.touched.status}
                                                    errors={formik.errors.status}
                                                    setFieldValue={formik.setFieldValue}
                                                    setOptions={courseStatus}
                                                    onChange={(e: any) => this.onChangeSelectCondition(e, formik)}
                                                    isTouched={formik.setFieldTouched}
                                                    placeHolder={T.t('r_gen_filter_course_parameter_courseStatus')}
                                                    isClearable={(true)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col text-right" style={{ paddingBottom: 10, paddingTop: 10 }}>
                                            <Button
                                                onClick={() => this.validateAndSubmit(formik)}
                                                button_type='primary'
                                                size='medium'
                                                iconPosition='left'
                                                materialicon='search'
                                                disabled={formik.isSubmitting}
                                                text={T.t('r_gen_search')} />
                                        </div>
                                    </div>
                                </form>
                            </>
                        );
                    }}
                </Formik>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ICourseList): ICourseList => {
    if (!state) {
        return ownProps;
    }
    const newProps: ICourseList = Object.assign({}, ownProps, {
        userHomeMyCourses: state.userHomePage.userHomeMyCourses,
        useHomeMyCoursesIsLoading: state.userHomePage.useHomeMyCoursesIsLoading,
        userType: state.login.identitiy.userType,
        userMyClasses: state.coursePage.userMyClasses,
        searchfilters: state.userHomePage.searchfilters
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.userHomePage.userHomeMyCourses === prev.userHomePage.userHomeMyCourses &&
        next.coursePage.userMyClasses === prev.coursePage.userMyClasses &&
        next.userHomePage.searchfilters === prev.userHomePage.searchfilters
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CFilterCourses = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(FilterCourses);

export default CFilterCourses;
